<template>
	<el-form-item :label="item.title + '：'">
		<el-input v-if="item.type == 'text'" v-model="form[item.name]" :disabled="item.permit_edit == 0" placeholder="请输入" style="width: 80%;" />
        <el-input v-if="item.type == 'number'" v-model="form[item.name]" :disabled="item.permit_edit == 0" placeholder="请输入" style="width: 300px;" />
        <el-date-picker v-if="item.type == 'datetime'" v-model="form[item.name]" :disabled="item.permit_edit == 0" type="datetime" value-format="yyyy-MM-dd hh:mm:ss" placeholder="选择日期时间"> </el-date-picker>
        <el-select v-if="item.type == 'option'" v-model="form[item.name]" :disabled="item.permit_edit == 0" placeholder="请选择">
            <el-option v-for="it in item.options" :key="it.id" :label="it.name" :value="it.id"> </el-option>
        </el-select>
        <el-select v-if="item.type == 'multi_option'" v-model="form[item.name]" multiple :disabled="item.permit_edit == 0" placeholder="请选择">
            <el-option v-for="it in item.options" :key="it.id" :label="it.name" :value="it.id + ''"> </el-option>
        </el-select>

        <el-upload
            v-if="item.type == 'image'" :disabled="item.permit_edit == 0"
            multiple :limit="10" name="image" :action="uploadUrl" list-type="picture-card" accept=".jpg,.png,.jpeg" :file-list="form[item.name]"
            :on-success="(res,file)=>{handleImgSuccess(res, file, item.name)}"
            :on-preview="handlePictureCardPreview"
            :on-remove="(file, fileList)=>handleRemoveImg(file, fileList, item.name)"
        >
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

        <el-upload
            v-if="item.type == 'file'" :disabled="item.permit_edit == 0"
            multiple :limit="10" name="file" :action="uploadFileUrl" :file-list="form[item.name]"
            :on-success="(res, file)=>{handleFileSuccess(res, file, item.name)}"
            :on-remove="(file, fileList)=>handleRemoveFile(file, fileList, item.name)"
            :on-exceed="handleExceed"
        >
            <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        
        <div v-if="item.type == 'admin'" style="display: flex;flex-direction: column;">
            <el-select v-model="form[item.name]" :disabled="item.permit_edit == 0" clearable placeholder="请选择员工" @visible-change='selectAdmin' style="width: 300px;">
                <el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id" />
            </el-select>
        </div>

        <el-cascader v-if="item.type == 'depart'" v-model="form[item.name]" :disabled="item.permit_edit == 0" :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" style="width: 300px;" @visible-change="getDepartmentLists"></el-cascader>

        <el-select v-if="item.type == 'user'" v-model="form[item.name]" placeholder="请选择" size="medium" style="width: 300px;"
            remote :remote-method="(val) => getUserLists(val)"  filterable clearable @visible-change="getUserLists" v-loading="userLoading" :disabled="item.permit_edit == 0"
        >
            <el-option v-for="(item, index) in userArr" :key="item.id" :label="item.name + ' / ' + item.phone" :value="item.id"></el-option>
            <el-pagination @current-change="userPageChange" :current-page="userSearch.page" :page-size="userSearch.limit" :total="userSearch.total" small
                layout="prev, next" prev-text="上一页" next-text="下一页" >
            </el-pagination>
        </el-select>
	</el-form-item>
</template>

<script>
    import base from '@/request/base.js';
    import { mapGetters } from 'vuex';
    import { oaApply, oaAudit, oaReapply, oaTemplate, fieldLists, DepartmentLists, adminLists, userLists, customizeAdd, customizeEdit, customizeDetail } from "@/request/apis.js"
	export default {
		props: {
			form: {
				type: Object
			},
			item: {
				type: Object
			},
		},
		data() {
			return {
                adminList: [],
                departArr: [],
                userSearch: {page: 1, limit: 10, total: 0},
                userLoading: false,
                userArr: [],
                dialogImageUrl: '',
                dialogVisible: false,
			}
		},
        computed: {
            ...mapGetters(['loginInfo']),
            uploadUrl: {
                get() {
                    return base.url + "/index/uploadImg?category=3&sid=" + this.loginInfo.sid + '&token=' + this.loginInfo.token + '&uid=' + this.loginInfo.admin_id;
                }
            },
            uploadFileUrl: {
                get() {
                    return base.url + "/index/uploadFile?category=3&sid=" + this.loginInfo.sid + '&token=' + this.loginInfo.token + '&uid=' + this.loginInfo.admin_id;
                }
            },
        },
        methods: {
            async selectAdmin(query){
                if (!query) {
                    return false;
                }
                const res = await adminLists({limit: 1000})
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.adminList = res.data;
            },
            async getDepartmentLists(){
                var res = await DepartmentLists({top: 1});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.departArr = res.data[0]['children'] || [];
            },
            async getUserLists(query, page){
                if(!query) return;
                this.userSearch.page = page ? page : this.userSearch.page;
                this.userLoading = true;
                var res = await userLists(this.userSearch);
                this.userLoading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.userArr = res.data;
                this.userSearch.total = res.count;
            },
            userPageChange(val){
                this.getUserLists(true, val);
            },

            handleImgSuccess(res, file, name) {
                console.log('handleImgSuccess', res, file);
                if (res.code) {
                    return this.$message.error('上传失败:' + res.msg);
                }
                this.form[name] = this.form[name] || [];
                this.form[name].push({url: res.data.url, name: res.data.filename, uid: file.uid});
                console.log('handleImgSuccess', name, this.form)
            },
            handleFileSuccess(res, file, name) {
                if (res.code) {
                    return this.$message.error('上传失败:' + res.msg);
                }
                this.form[name] = this.form[name] || [];
                this.form[name].push({url: res.data.url, name: res.data.filename, uid: file.uid});
            },
            handleRemoveImg(file, fileList, name) {
                console.log('handleRemoveImg', file, fileList, name);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemoveFile(file, fileList, name) {
                console.log('handleRemoveFile', file, fileList, name);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
        }
	}
</script>

<style scoped>
</style>